import styled from "styled-components";
import { borders, colors } from "@sonder/ui/source/styled/theme";

export const EmptyContent = styled.div`
  align-items: center;
  align-self: center;
  background: ${colors.white};
  border-radius: 0.3rem;
  border: ${borders.standard};
  color: ${colors.blue2};
  display: flex;
  flex-wrap: nowrap;
  text-align: center;
  justify-content: center;
  line-height: 2.2rem;
  margin-top: 5rem;
  padding: 0 2rem;
`;
